module.exports = __webpack_public_path__ + "static/media/45d.968f9b85.jpg";